import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBookmark } from '@fortawesome/free-regular-svg-icons';

const BookmarkOutlineIcon = (props) => <FontAwesomeIcon icon={faBookmark} {...props} />;

export default BookmarkOutlineIcon;
